import React from 'react';
import styles from './styles.module.scss';
import { jsxs as _jsxs } from "react/jsx-runtime";

const ErrorsButton = _ref => {
  let {
    counter = 0,
    onClick
  } = _ref;
  return /*#__PURE__*/_jsxs("button", {
    className: styles.errorsIndicator,
    onClick: onClick,
    "data-ignore-click-away": "true",
    children: [counter, " Error", counter > 1 && 's']
  });
};

export default ErrorsButton;